/**
 * A ticket type's percentage fee travels in two units:
 *
 * - the WIRE (ticketing-api, `ticket_types.percentage_fee`, the fee defaults) holds
 *   PERCENT: 5.5 means 5.5%;
 * - the event wizard's form holds a DECIMAL: 0.055, four decimals at most.
 *
 * Both directions live here, rounded, so a value survives the round trip exactly.
 * A bare `decimal * 100` does not: 0.029 * 100 is 2.9000000000000004 in floats.
 */

/** Form decimal → wire percent. Four form decimals are two percent decimals. */
export const toWirePercentageFee = (decimal: number): number =>
  Math.round(decimal * 10000) / 100;

/** Wire percent → form decimal, at the four decimals the form keeps. */
export const toFormPercentageFee = (percent: number): number =>
  Math.round(percent * 100) / 10000;
